import type {
    CreateUser,
    UpdateUser,
    UserEntry,
    UserNotificationsUpdate,
    UserWithLawFirm,
} from '@common/types/users';
import axiosInstance from '@/services/axiosInstance';

export async function fetchAllUsers(lawFirmId?: number) {
    return axiosInstance.get<UserEntry[]>('/api/v1/users', {
        params: { LawFirmIds: lawFirmId ? [lawFirmId] : undefined },
        paramsSerializer: { indexes: null },
    });
}

export async function updateUserNotifications(userId: number, payload: UserNotificationsUpdate) {
    return axiosInstance.put(`/api/v1/users/${userId}/notifications`, payload);
}

export async function fetchUserById(userId: number) {
    return axiosInstance.get<UserWithLawFirm>(`/api/v1/users/${userId}`);
}

export async function createUser(createData: CreateUser) {
    return axiosInstance.post<UserWithLawFirm>('/api/v1/users', createData);
}

export async function updateUser(userId: number, updateData: UpdateUser) {
    return axiosInstance.put<UserWithLawFirm>(`/api/v1/users/${userId}`, updateData);
}

export async function updateUserSignature(userId: number, signature: string) {
    return axiosInstance.put(`/api/v1/users/signature/${userId}`, signature, {
        headers: { 'Content-Type': 'application/json' },
    });
}

export async function createGraphUser(createData: CreateUser) {
    return axiosInstance.post<string>('/api/v1/graph', createData);
}

export async function resendAccountDetails(email: string) {
    return axiosInstance.post<string>('/api/v1/graph/resend', {
        email: email.trim().toLowerCase(),
    });
}

export async function disableUserAccount(email: string) {
    return axiosInstance.post('/api/v1/graph/disable', {
        email: email.trim().toLowerCase(),
    });
}

export async function enableUserAccount(email: string) {
    return axiosInstance.post('/api/v1/graph/enable', {
        email: email.trim().toLowerCase(),
    });
}

export async function deleteUser(userId: number, email: string) {
    return axiosInstance.delete(`/api/v1/users/${userId}`, {
        data: {
            email: email.trim().toLowerCase(),
        },
    });
}
